// StoreTabs.js
import images from "../../../../../../../../../utilities/images/images";
import "./StoreTabs.scss";

export const StoreTabs = (props) => {
  const { packageData, active, setActive } = props;

  const changeTab = (tab) => setActive(tab);

  const whatsAppMessageSender = () => {
    const phoneNumber = parseInt(packageData?.motion_whatsapp_no || "");
    const url = `https://api.whatsapp.com/send?phone=${phoneNumber}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="tabs-container">
      <div className="tabs">
        <div
          className={`tab ${active === "desc" ? "active" : ""}`}
          onClick={() => changeTab("desc")}
        >
          <i className="icon description-icon" />
          Description
        </div>
        {packageData?.subject && packageData.subject.length > 0 && (
          <div
            className={`tab ${active === "subjects" ? "active" : ""}`}
            onClick={() => changeTab("subjects")}
          >
            <i className="icon subjects-icon" />
            Subjects
          </div>
        )}
      </div>

      <div className="contact-icons">
        <div className="icon-button whatsapp" onClick={whatsAppMessageSender}>
          <img src={images.whatsaap} alt="WhatsApp" />
        </div>
        <div className="icon-button call">
          <a href={`tel:${packageData?.motion_mobile_no || ""}`}>
            <img src={images.phoneCall} alt="Call" />
          </a>
        </div>
      </div>
    </div>
  );
};
